import {
  ReconciliationReportResponse,
  ReconciliationSummaryResponse,
} from '../../Interfaces/api/backoffice/reconciliation.interface';
import { ReconciliationFinding } from './reconciliation-finding.model';

export class ReconciliationReport {
  id = '';
  scope = '';
  organization_id: string | null = null;
  checked_orgs = 0;
  drifted_orgs = 0;
  critical_orgs = 0;
  summary: ReconciliationSummaryResponse | null = null;
  ran_at: string | null = null;
  ran_by: string | null = null;

  constructor(data: Partial<ReconciliationReportResponse> = {}) {
    Object.assign(this, data);
  }

  get isScheduled(): boolean {
    return this.ran_by === null;
  }

  get isTruncated(): boolean {
    return this.summary?.truncated ?? false;
  }

  get findings(): ReconciliationFinding[] {
    return (this.summary?.organizations ?? []).map((row) => new ReconciliationFinding(row));
  }

  get shapes(): string[] {
    return this.summary?.shapes ?? [];
  }
}
